import { render, staticRenderFns } from "./cancellation-and-refund.vue?vue&type=template&id=f8a50e62&scoped=true&"
import script from "./cancellation-and-refund.vue?vue&type=script&lang=js&"
export * from "./cancellation-and-refund.vue?vue&type=script&lang=js&"
import style0 from "./cancellation-and-refund.vue?vue&type=style&index=0&id=f8a50e62&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8a50e62",
  null
  
)

export default component.exports